"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedExperiences() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const experiences = [{
    id: 1,
    title: "Degustación de Mariscos",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/seafood_tasting_platter.png",
    description: "Sabores frescos del océano"
  }, {
    id: 2,
    title: "Atardecer en la Terraza",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/sunset_terrace_view.png",
    description: "Vistas inolvidables"
  }, {
    id: 3,
    title: "Cena Privada",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/private_dinner_experience.png",
    description: "Experiencia exclusiva"
  }];
  return <section id="experiencias-destacadas" ref={containerRef} className="bg-secondary py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground-secondary text-center mb-16 opacity-0 transition-opacity duration-700" style={{
        opacity: isVisible ? 1 : 0
      }}>
          Experiencias destacadas
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {experiences.map((experience, i) => <Card key={experience.id} data-index={i} className="group bg-secondary border border-white/10 overflow-hidden shadow-soft hover:shadow-strong transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:-translate-y-2 opacity-0 animate-fade-in-up pt-0" style={{
          animationDelay: isVisible ? `${i * 150}ms` : "0ms",
          opacity: isVisible ? 1 : 0
        }}>
              <div className="relative h-64 overflow-hidden">
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" style={{
              backgroundImage: `url(${experience.image})`,
              filter: "sepia(0.3) saturate(1.2) brightness(1.1)"
            }} />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-secondary/60" />
              </div>

              <CardContent className="space-y-4 px-6 py-6">
                <h3 className="font-display text-2xl font-bold text-foreground-secondary leading-tight">
                  {experience.title}
                </h3>
                <p className="text-foreground-secondary/80 text-sm">
                  {experience.description}
                </p>

                <Button asChild className="w-full bg-primary text-foreground-primary font-semibold px-6 py-3 rounded-md shadow-[0_2px_0_0_rgba(0,0,0,0.15)] hover:bg-primary-hover hover:shadow-medium hover:-translate-y-1 hover:border-accent border-transparent border-2 active:bg-primary-active active:translate-y-0 focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
                  <Link to="#">Ver más</Link>
                </Button>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}